import React from 'react';
import styled from 'styled-components';
import { Clickable } from '../../../styles/Animation';
export const InfoTipWrapper = styled.div `
  ${Clickable}
  margin-left: 0.5rem;
`;
export const InfoTip = styled.img `
  opacity: 0.3;
  width: 1rem;
  height: 1rem;
`;
export const InfoTipComponent = ({ onClick, }) => (React.createElement(InfoTipWrapper, { onClick: onClick },
    React.createElement(InfoTip, { src: "/icons/information-black2.png" })));
